// translations
const { I18n } = require("i18n-js")

// Deep merge function to properly merge nested translation objects
function deepMerge(...objects) {
  const result = {}
  for (const obj of objects) {
    for (const key in obj) {
      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key]) &&
        typeof result[key] === "object" &&
        result[key] !== null
      ) {
        result[key] = deepMerge(result[key], obj[key])
      } else {
        if (process.env.NODE_ENV === "development" && key in result) {
          throw new Error(`Duplicate translation key: "${key}"`)
        }
        result[key] = obj[key]
      }
    }
  }
  return result
}

// Winddle UI (first, so phrase files can override)
const winddleUiEn =
  require("@winddle/winddle-ui/src/utils/translations/winddle-ui.en.yml").en
const winddleUiFr =
  require("@winddle/winddle-ui/src/utils/translations/winddle-ui.fr.yml").fr

// EN
const adminEn = require("@phrase/locales/admin.en.yml").en
const activityEn = require("@phrase/locales/activity.en.yml").en
const aiEn = require("@phrase/locales/ai.en.yml").en
const contactEn = require("@phrase/locales/contact.en.yml").en
const dashboardEn = require("@phrase/locales/dashboard.en.yml").en
const fieldsEn = require("@phrase/locales/fields.en.yml").en
const invoiceEn = require("@phrase/locales/invoice.en.yml").en
const modelsEn = require("@phrase/locales/models.en.yml").en
const messagingEn = require("@phrase/locales/messaging.en.yml").en
const notificationEn = require("@phrase/locales/notification.en.yml").en
const orderEn = require("@phrase/locales/order.en.yml").en
const performanceEn = require("@phrase/locales/performance.en.yml").en
const planningEn = require("@phrase/locales/planning.en.yml").en
const productEn = require("@phrase/locales/product.en.yml").en
const settingsEn = require("@phrase/locales/settings.en.yml").en
const statisticsEn = require("@phrase/locales/statistics.en.yml").en
const transportEn = require("@phrase/locales/transport.en.yml").en
const utilitiesEn = require("@phrase/locales/utilities.en.yml").en
const mailersEn = require("@phrase/locales/mailers.en.yml").en
const policyEn = require("@phrase/locales/policy.en.yml").en
const publicEn = require("@phrase/locales/public.en.yml").en
const warehouseEn = require("@phrase/locales/warehouse.en.yml").en

// FR
const adminFr = require("@phrase/locales/admin.fr.yml").fr
const activityFr = require("@phrase/locales/activity.fr.yml").fr
const aiFr = require("@phrase/locales/ai.fr.yml").fr
const contactFr = require("@phrase/locales/contact.fr.yml").fr
const dashboardFr = require("@phrase/locales/dashboard.fr.yml").fr
const fieldsFr = require("@phrase/locales/fields.fr.yml").fr
const invoiceFr = require("@phrase/locales/invoice.fr.yml").fr
const modelsFr = require("@phrase/locales/models.fr.yml").fr
const messagingFr = require("@phrase/locales/messaging.fr.yml").fr
const notificationFr = require("@phrase/locales/notification.fr.yml").fr
const orderFr = require("@phrase/locales/order.fr.yml").fr
const performanceFr = require("@phrase/locales/performance.fr.yml").fr
const planningFr = require("@phrase/locales/planning.fr.yml").fr
const productFr = require("@phrase/locales/product.fr.yml").fr
const settingsFr = require("@phrase/locales/settings.fr.yml").fr
const statisticsFr = require("@phrase/locales/statistics.fr.yml").fr
const transportFr = require("@phrase/locales/transport.fr.yml").fr
const utilitiesFr = require("@phrase/locales/utilities.fr.yml").fr
const mailersFr = require("@phrase/locales/mailers.fr.yml").fr
const policyFr = require("@phrase/locales/policy.fr.yml").fr
const publicFr = require("@phrase/locales/public.fr.yml").fr
const warehouseFr = require("@phrase/locales/warehouse.fr.yml").fr

// Concat (using deepMerge to properly merge nested objects like utilities.*)
const translations = {
  en: deepMerge(
    winddleUiEn,
    activityEn,
    adminEn,
    aiEn,
    contactEn,
    dashboardEn,
    fieldsEn,
    invoiceEn,
    modelsEn,
    messagingEn,
    notificationEn,
    orderEn,
    performanceEn,
    planningEn,
    productEn,
    settingsEn,
    statisticsEn,
    transportEn,
    utilitiesEn,
    mailersEn,
    policyEn,
    publicEn,
    warehouseEn
  ),
  fr: deepMerge(
    winddleUiFr,
    adminFr,
    activityFr,
    aiFr,
    contactFr,
    dashboardFr,
    fieldsFr,
    invoiceFr,
    modelsFr,
    messagingFr,
    notificationFr,
    orderFr,
    performanceFr,
    planningFr,
    productFr,
    settingsFr,
    statisticsFr,
    transportFr,
    utilitiesFr,
    mailersFr,
    policyFr,
    publicFr,
    warehouseFr
  )
}

const i18n = new I18n(translations)

// lookup doesn't exist anymore in i18n-js v4, we recreate it here
i18n.lookup = function (key, options = {}) {
  const result = this.t(key, { ...options, defaultValue: "__MISSING__" })
  return result === "__MISSING__" ? null : result
}

module.exports = i18n
